import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import {
  api_candidate_comments,
  api_candidate_emails,
  api_candidate_reviews,
  api_candidate_timeline,
  api_job,
} from '../../constants/apiRoutes';
import { isObjectEmpty } from '../../utility/helpers';
import { parseDuplicateParameters } from '../../utility/uiUtils';

// ------------------------------------
// Constants
// ------------------------------------

const SET_JOB = 'SET_JOB';
const SET_REVIEWS = 'SET_REVIEWS';
const SET_COMMENTS = 'SET_COMMENTS';
const SET_EMAILS = 'SET_EMAILS';
const SET_TIMELINE = 'SET_TIMELINE';
const LOAD_MORE_TIMELINE = 'LOAD_MORE_TIMELINE';

const initialState = {
  job: {},
  reviews: [],
  comments: [],
  emails: [],
  timeline: {},
};

// ------------------------------------
// Actions
// ------------------------------------

const setJob = createAction(SET_JOB);
const setReviews = createAction(SET_REVIEWS);
const setComments = createAction(SET_COMMENTS);
const setEmails = createAction(SET_EMAILS);
const setTimeline = createAction(SET_TIMELINE);
const loadMoreTimeline = createAction(LOAD_MORE_TIMELINE);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_JOB]: (state, { payload }) => {
    return {
      ...state,
      job: payload,
    };
  },
  [SET_REVIEWS]: (state, { payload }) => {
    return {
      ...state,
      reviews: payload,
    };
  },
  [SET_COMMENTS]: (state, { payload }) => {
    return {
      ...state,
      comments: payload,
    };
  },
  [SET_EMAILS]: (state, { payload }) => {
    return {
      ...state,
      emails: payload,
    };
  },
  [SET_TIMELINE]: (state, { payload }) => {
    return {
      ...state,
      timeline: payload,
    };
  },
  [LOAD_MORE_TIMELINE]: (state, { payload }) => {
    return isObjectEmpty(payload)
      ? { ...state, timeline: payload }
      : {
          ...state,
          timeline: {
            ...payload,
            results: state.timeline.results
              ? [...state.timeline.results, ...payload.results]
              : [...payload.results],
          },
        };
  },
};

// ------------------------------------
// API calls
// ------------------------------------

export const getJob = (dispatch, jobId) => {
  return http.get(api_job(jobId)).then(({ data }) => {
    dispatch(setJob(data));

    return data;
  });
};

export const getCandidateReviews = (dispatch, jobId, candidateId) => {
  return http
    .get(`${api_candidate_reviews(jobId)}?candidate=${candidateId}`)
    .then(({ data }) => {
      dispatch(setReviews(data));

      return data;
    });
};

export const getCandidateComments = (dispatch, jobId, candidateId) => {
  return http
    .get(`${api_candidate_comments(jobId)}?candidate=${candidateId}`)
    .then(({ data }) => {
      dispatch(setComments(data));
    });
};

export const getCandidateEmails = (dispatch, jobId, candidateId) => {
  return http
    .get(`${api_candidate_emails(jobId)}?candidate=${candidateId}`)
    .then(({ data }) => {
      dispatch(setEmails(data));
    });
};

export const getCandidateTimeline = (
  dispatch,
  jobId,
  candidateId,
  params = {},
  isLoadMore = false
) => {
  return http
    .get(api_candidate_timeline(jobId, candidateId), {
      params,
      paramsSerializer: p => parseDuplicateParameters(p),
    })
    .then(({ data }) => {
      dispatch(isLoadMore ? loadMoreTimeline(data) : setTimeline(data));
      return data;
    });
};

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearJob = () => setJob(initialState.job);
export const clearReviews = () => setReviews(initialState.reviews);
export const clearComments = () => setComments(initialState.comments);
export const clearEmails = () => setEmails(initialState.emails);
export const clearTimeline = () => setTimeline(initialState.timeline);
